<script>
  import { Collapse } from "sveltestrap";
  import {
    openSystemTooltip,
    closeSystemTooltip,
    openContextMenu,
    closeContextMenu
  } from "../../editor/utility.js";
  export let node = {};
  export let level = 0;
  export let view = node.show_children || false;
</script>

{#if node}
  <div
    class="node"
    style={`margin-left: ${0.25 * level}rem;`}
    on:click={() => {
      view = !view;
    }}
    on:mouseover={(event) => {
      if (node.find) {
        node.find(event);
      }
      if (node.run) {
        openSystemTooltip(
          event,
          "Double-click to edit." +
            (node.lock?.[0] === "this"
              ? " This element is locked for responsive alternatives."
              : " This element has a child(ren) locked for responsive alternatives.")
        );
      } else if (node.lock.length > 0) {
        openSystemTooltip(
          event,
          node.lock?.[0] === "this"
            ? " This element is locked for responsive alternatives."
            : " This element has a child(ren) locked for responsive alternatives."
        );
      }
    }}
    on:focus={(event) => {
      if (node.find) {
        node.find(event);
      }
      if (node.run) {
        openSystemTooltip(
          event,
          "Double-click to edit." +
            (node.lock?.[0] === "this"
              ? " This element is locked for responsive alternatives."
              : " This element has a child(ren) locked for responsive alternatives.")
        );
      } else if (node.lock.length > 0) {
        openSystemTooltip(
          event,
          node.lock?.[0] === "this"
            ? " This element is locked for responsive alternatives."
            : " This element has a child(ren) locked for responsive alternatives."
        );
      }
    }}
    on:mousemove={(event) => {
      if (node.run) {
        openSystemTooltip(
          event,
          "Double-click to edit." +
            (node.lock?.[0] === "this"
              ? " This element is locked for responsive alternatives."
              : " This element has a child(ren) locked for responsive alternatives.")
        );
      } else if (node.lock.length > 0) {
        openSystemTooltip(
          event,
          node.lock?.[0] === "this"
            ? " This element is locked for responsive alternatives."
            : " This element has a child(ren) locked for responsive alternatives."
        );
      }
    }}
    on:mouseout={(event) => {
      if (node.unfind) {
        node.unfind(event);
      }
      closeSystemTooltip();
    }}
    on:blur={(event) => {
      if (node.unfind) {
        node.unfind(event);
      }
      closeSystemTooltip();
      console.log("...");
      closeContextMenu();
    }}
    on:dblclick={(event) => {
      if (node.run) {
        node.run(event, node);
      }
      closeSystemTooltip();
    }}
    on:contextmenu={(event) => {
      if (node.contextMenus?.constructor?.name === "Array") {
        event.preventDefault();
        openContextMenu(event, node.contextMenus);
        console.log("..x");
      }
    }}
  >
    {#if node.children && node.children.length > 0}
      <i class={`bi bi-${view ? "caret-down-fill" : "caret-right"} me-1`} />
    {:else}
      <i class="bi bi-dash me-1" />
    {/if}
    <span>
      <i class={`bi bi-${node.icon || "dot"} me-1`} />
      {node.name}
      {#if node.lock?.length == 1 && node.lock[0] == "this"}<sup
          ><i class="bi bi-lock-fill" alt="locked" /></sup
        >{:else if node.lock?.length > 0}<sup
          ><i
            class="bi bi-lock-fill"
            alt="Has locked elements"
            style="opacity: 0.5;"
          /></sup
        >
      {/if}
      {#if node.run}<i
          class={`bix bi bi-pencil ms-1`}
          alt="Edit this element"
        />{/if}
      {#if node.contextMenus}<i
          class={`bix bi bi-three-dots-vertical ms-1`}
          alt="Right click for context menu"
        />{/if}
    </span>
  </div>
  {#if node.children?.constructor.name === "Array"}
    <Collapse isOpen={view}>
      {#each node.children as child}
        <svelte:self node={child} level={level + 1} />
      {/each}
    </Collapse>
  {/if}
{/if}

<style>
  .node {
    font-size: 0.75rem;
    font-weight: 400;
    padding: 0.15rem 0.25rem;
    border-radius: var(--default-radius);
    border: 1px solid transparent;
  }
  .node:hover {
    font-weight: 400;
    background-color: rgba(255, 255, 255, 1);
    border: 1px solid #dddddd;
  }
  .bix {
    display: none;
  }
  .node:hover .bix {
    display: initial;
  }
</style>
